import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import FilterContainer from './Filter/Filter';
import styles from './ListView.scss';
import SidecarContainer from './Sidecar/Sidecar';
import MobileTable from './Table/MobileTable';
import Table from './Table/Table';

const ListView = () => {
  const isMobile = useSelector(select.device.isMobile);
  const { greaterThan } = useScreenSize();
  const smallScreen = isMobile || !greaterThan(Size.Medium);

  if (smallScreen) {
    return (
      <div>
        <MobileTable />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <FilterContainer />
      <Table />
      <SidecarContainer />
    </div>
  );
};

export default ListView;
